/**
 * HR-dashboard — aantallen en verdelingen (geslacht, generatie, contracttype …),
 * alleen als aggregaat: geen namen, geen geboortedatums (gap-analyse #8, 26 sep 2026).
 * Recht: hr_leveranciers (view), op de server afgedwongen.
 */
import React, { useCallback, useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Alert, Box, Button, CircularProgress, Typography } from '@mui/material';
import PageHeader from '../../ui-components/PageHeader';
import { BACKEND_URL } from '../../utils/apiConfig';
import { ACCENT, INK, Kerncijfer, Verdeling, bijgewerktTekst, haalJson } from '../Leveranciers/hrUi';

export default function HrDashboard() {
  const [d, setD] = useState(null);
  const [fout, setFout] = useState(null);

  const laad = useCallback(async () => {
    setFout(null);
    try { setD(await haalJson(`${BACKEND_URL}/Api/medewerkers/dashboard`, 'HR-dashboard laden')); }
    catch (e) { setFout(e.message); }
  }, []);
  useEffect(() => { laad(); }, [laad]);

  const a = d?.aantallen || {};
  return (
    <Box sx={{ width: '100%', maxWidth: 1800, mx: 'auto', px: { xs: 2, sm: 3, md: 5 }, pt: { xs: 3, md: 5 }, pb: 6 }}>
      <PageHeader
        icon="diversity_3"
        title="HR-dashboard"
        subtitle="Samenstelling van het team — alleen totalen, nooit per persoon"
        accent={ACCENT}
        rightActions={<Button component={RouterLink} to="/medewerkers" sx={{ textTransform: 'none' }}>Naar de galerij</Button>}
      />
      {fout && <Alert severity="error" action={<Button color="inherit" size="small" onClick={laad}>Opnieuw</Button>}>{fout}</Alert>}
      {!d && !fout && <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}><CircularProgress /></Box>}
      {d && (
        <>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 3 }}>
            <Kerncijfer label="Medewerkers" waarde={a.medewerkers} />
            <Kerncijfer label="Stagiairs" waarde={a.stagiairs} />
            <Kerncijfer label="Oud-medewerkers" waarde={a.oudMedewerkers} toelichting={a.oudStagiairs ? `+ ${a.oudStagiairs} oud-stagiairs` : undefined} />
            <Kerncijfer label="Freelancers" waarde={a.freelancers} toelichting="actief" />
            <Kerncijfer label="Bedrijven" waarde={a.bedrijven} toelichting="leveranciers" />
          </Box>
          <Typography sx={{ fontSize: 12, color: INK.stil, mb: 1.5 }}>
            Verdelingen gaan over de huidige {d.totaalHuidig} medewerkers en stagiairs (contracttype: alleen medewerkers). {bijgewerktTekst(d.bijgewerkt)}
          </Typography>
          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', md: '1fr 1fr', xl: '1fr 1fr 1fr' }, gap: 2 }}>
            <Verdeling titel="Geslacht" rijen={d.geslacht} />
            <Verdeling titel="Generatie" rijen={d.generatie} />
            <Verdeling titel="Contracttype" rijen={d.contracttype} />
            <Verdeling titel="Rijbewijs B" rijen={d.rijbewijsB} />
            <Verdeling titel="Magazijnsleutel" rijen={d.magazijnsleutel} />
            <Verdeling titel="Functies" rijen={(d.functies || []).slice(0, 12)} />
          </Box>
        </>
      )}
    </Box>
  );
}
